import React, { useContext } from "react";
import { Route, Routes } from 'react-router-dom';

import { AppContext} from '../../AppContext';


import SummaryContracts from "./SummaryContracts";
import SummaryDemo from "./SummaryDemo";
import '../css/GPTApp.css';



function QSummary() {

    const { userID, userStatus, loading } = useContext(AppContext).contextValue;
    if (loading) {
        return <div></div>;
    }

    return (
            <div>
                <Routes>
                    <Route
                    path="*"
                    element={userStatus === 'demo' ? <SummaryDemo /> : <SummaryContracts userID= {userID}/>}
                    />
                </Routes>
            </div>
    );
}

export default QSummary; 